<template>
  <div class="quick_response_component">
    <md-dialog :md-active.sync="quick_response.show" @md-closed="resetData">
      <md-dialog-title>
        Quick Response
        <span class="md-caption">
          (ID: {{ quick_response.application && quick_response.application.id }})
        </span>
      </md-dialog-title>
      <md-dialog-content>
        <validated-select-input
          class="md-layout-item md-size-85"
          label="Response Type"
          v-model="response_type"
          :options="{
            'email': 'Email',
            'sms': 'SMS',
          }"
          required
        ></validated-select-input>
        <validated-select-input
          class="md-layout-item md-size85"
          label="Template"
          v-model="selected_template"
          :options="communication_templates"
          :disabled="!response_type"
          required
        ></validated-select-input>
        <edit-quick-response
          v-if="quick_response_content.body && quick_response_content.body !== ''"
          v-model="quick_response_content.body" 
          :editor-type="response_type"
        />
        <md-dialog-actions>
          <md-button class="md-primary md-simple" @click="onClose">Close</md-button>
          <md-button class="md-primary" @click="onSend" :disabled="disableSend">Send</md-button>
          <md-button class="md-primary" @click="onRetrieve" :disabled="disableSend">Reset Content</md-button>
        </md-dialog-actions>
      </md-dialog-content>
    </md-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ValidatedSelectInput from '@/components/ValidatedInput/ValidatedSelectInput'
import AlertDialog from "@/components/Dialogs/AlertDialog";
import EditQuickResponse from "../Editors/EditQuickResponse.vue";

export default {
  components: {
    ValidatedSelectInput,
    AlertDialog,
    EditQuickResponse,
  },
  props: {
    quick_response: {
      type: null,
      default: () => null,
    }
  },
  data() {
    return {
      response_type: null,
      communication_templates: [],
      selected_template: null,
      quick_response_content: {
        "body": "",
        "subject": "",
      },
    }
  },
  watch: {
    "response_type"(newVal){
      if (newVal){
        this.selected_template = null;
        this.communication_templates = this.properties.communication_templates[newVal];
        this.quick_response_content = {
          "body": "",
          "subject": "",
        };
      }
    },
    "selected_template"(newVal) {
      if (newVal) {
        this.onRetrieve();
      }
    }
  },
  computed: {
    ...mapGetters([
      'properties',
    ]),
    disableSend() {
      return this.response_type == null || this.selected_template == null;
    },
  },
  methods: {
    onClose() {
      this.$store.commit('set_application_quick_response_dialog', null)
    },
    async onSend() {
      const payload = {
        "application_id": this.quick_response.application.id,
        "type": this.response_type,
        ...this.quick_response_content
      } 
      const response = await this.$store.dispatch("send_quick_response", payload);
      if (response !== true) {
        await this.showAlertDialog("Failed", response);
      } else {
        const successMessage = "Send " + this.selected_template + " " + this.response_type + " to applicant."
        await this.showAlertDialog("Success", successMessage);
      }
    },
    async onRetrieve() {
      const payload = {
        'application_id': this.quick_response.application.id,
        'template': this.selected_template,
        'type': this.response_type,
      }
      const response = await this.$store.dispatch("get_quick_response_content", payload);
      if (response["error"]) {
        await this.showAlertDialog("Failed", response["error"]);
        return;
      }
      this.quick_response_content = { ...response };
    },
    showAlertDialog(title, message) {
      return this.$modal.show(AlertDialog, { title, message });
    },
    resetData() {
      this.selected_template = null;
      this.response_type = null;
      this.quick_response_content = {
        "body": "",
        "subject": "",
      };
    },
  },
  async beforeCreate() {
    const params = {
      types: [
        'communication_templates',
      ],
    }
    await this.$store.dispatch('fetch_types', { params });
  },
}
</script>

<style lang="scss" scoped>
::v-deep strong {
  font-weight: bold;
}

::v-deep ul, ::v-deep ol {
  padding: revert;
}
</style>
